<div class="dialog-content">
  <form [formGroup]="invitationForm" class="k-form">
    <kendo-formfield orientation="horizontal">
      <kendo-label [for]="invoiceTitle" text="Email"></kendo-label>
      <kendo-textbox
        showErrorIcon="initial"
        [formControlName]="formControlNames.Email"
        #invoiceTitle
      >
      </kendo-textbox>
    </kendo-formfield>
  </form>
</div>

<footer class="k-d-flex k-justify-content-between">
  <button (click)="close()" kendoButton size="large" themeColor="secondary" class="k-mr-4 !k-pr-4">
    <span class="custom-symbol close k-mr-3"></span>
    <span class="label">Schließen</span>
  </button>

  <button kendoButton (click)="invite()" class="!k-pr-4" themeColor="base" size="large">
    <fa-icon class="add k-text-white k-mr-3" [icon]="faCirclePlus"></fa-icon>
    <span class="label">Einladung senden</span>
  </button>
</footer>
